//
// ===== File globals.ts    
//
'use strict';

//export const baseUrl='http://localhost:4200/';
export const baseUrl=' http://cjcwealth360.com';
